import { createContext } from "react";
import { Proto } from "@probe/shared";

export const UserContext = createContext<Proto.Users.User>((<any>null) as Proto.Users.User)
export const SessionIdContext = createContext<string>("")